import React, {
  ReactElement,
} from 'react';
import {
  Loader, Select,
} from 'idsk-react-components';
import { ExpansionPanel } from 'slovlex-idsk-react-components';
import './sidePanel.scss';
import SearchInput from './SearchInput';
import PublikovanyTerminFilter from '../../../model/PublikovanyTerminFilter';
import { SafeParameterSetter } from '../../../model/SafeParameterSetter';
import useTezaurusList from '../../Admin/Tezaurus/List/hook/useTezaurusList';
import PouzitiePredpisMultiSelect from './PouzitiePredpisMultiSelect';

interface Props {
  filter: PublikovanyTerminFilter;
  onUpdateField?: SafeParameterSetter<PublikovanyTerminFilter>;
  filterCopy: PublikovanyTerminFilter;
  onUpdateFieldCopy: SafeParameterSetter<PublikovanyTerminFilter>;
  setFilter: (filter: PublikovanyTerminFilter) => void;
}

const MobileFilters = ({
  filter,
  onUpdateField,
  filterCopy,
  onUpdateFieldCopy,
  setFilter,
}: Props): ReactElement => {
  const {
    tezaurusList,
    tezaurusStatus,
  } = useTezaurusList();

  return (
    <div className="publikovany-termin-list-side-panel">
      <ExpansionPanel title="Tezaurus" className="first-expansion-panel">
        <div className="slovlex-idsk-side-panel-input-wrapper">
          <Loader loading={tezaurusStatus.loading}>
            <Select
              id="tezaurus"
              width="full"
              name="tezaurus"
              value={filter?.tezaurus?.uuid ? filter.tezaurus.uuid : ''}
              onChange={({ target }) => {
                const selectedTezaurus = tezaurusList.find(tezaurus => tezaurus.uuid === target.value);
                onUpdateField('tezaurus', target.value === '' ? null : selectedTezaurus);
              }}
            >
              <option key="Vyberte" value="">Vyberte</option>
              {(tezaurusList && tezaurusList?.length > 0) ? (
                <>
                  {tezaurusList
                    ?.map(tezaurus => (
                      <option
                        key={tezaurus.uuid}
                        value={tezaurus.uuid}
                      >
                        {tezaurus.nazov}
                      </option>
                    ))}
                </>
              ) : (
                <option key="emptyOption" value="emptyOption" disabled>
                  Nenašiel sa žiadny záznam.
                </option>
              )}
            </Select>
          </Loader>
        </div>
      </ExpansionPanel>
      <ExpansionPanel title="Legálny zdroj">
        <SearchInput
          filterCopy={filterCopy}
          filterSearchText={filterCopy?.searchTextLegalnyZdroj}
          fieldName="searchTextLegalnyZdroj"
          onUpdateFieldCopy={onUpdateFieldCopy}
          setFilter={setFilter}
          className="slovlex-idsk-side-panel-input-wrapper"
          maxLength={254}
        />
      </ExpansionPanel>
      <ExpansionPanel title="Doktrinálny zdroj">
        <SearchInput
          filterCopy={filterCopy}
          filterSearchText={filterCopy?.searchTextDoktrinalnyZdroj}
          fieldName="searchTextDoktrinalnyZdroj"
          onUpdateFieldCopy={onUpdateFieldCopy}
          setFilter={setFilter}
          className="slovlex-idsk-side-panel-input-wrapper"
          maxLength={254}
        />
      </ExpansionPanel>
      <ExpansionPanel title="Použité v právnom predpise">
        <PouzitiePredpisMultiSelect data={filter} onUpdateField={onUpdateField} />
      </ExpansionPanel>
    </div>
  );
};

export default MobileFilters;
